<div class="rename-block flexbox-column p-3">
    <div class="button-group gap-8">
        <button mat-button class="button-text" title="Bold" [ngClass]="{'activeBtnFormat': rename().isBolded }"
            (click)="onChange('bold')">
            <i class="fa-regular fa-b"></i>
        </button>
        <button mat-button class="button-text">
            |
        </button>
        <button mat-button class="button-text" title="Breakpoint" (click)="onChange('newline')">
            <i class="fa-regular fa-arrow-rotate-left newlineEnter"></i>
        </button>
    </div>
    <mat-form-field class="fixed-label w-100" floatLabel="always">
        <mat-label *ngIf="!rename().isSubheader">Rename Column Name <span class="text-error">*</span></mat-label>
        <mat-label *ngIf="rename().isSubheader">Rename Subheader <span class="text-error">*</span></mat-label>
        <textarea [ngClass]="{'fw-semibold': rename().isBolded }" class="text-end" id="textAreaId" matInput
            cdkTextareaAutosize #autoSize="cdkTextareaAutosize" [formControl]="renameText"
            (keydown.shift.enter)="onKeydown($event)" (paste)="onPaste($event)" (keydown.enter)="onKeydown($event)"
            (input)="onInputChange($event)" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5">
        </textarea>
    </mat-form-field>
    <p>
        <span class="fw-semibold">Note: </span>Press Shift+Enter to transition text to a new line or utilize the final
        arrow icon to create a breakpoint within text.
    </p>
    <div class="button-group gap-8 justify-content-end">
        <button mat-button mat-stroked-button color="dark" class="button-medium" (click)="cancelRename()">
            <span class="button-label">Cancel</span>
        </button>
        <button mat-button mat-flat-button color="primary" class="button-medium"
            [disabled]="((rename()?.name === originalName) && (rename()?.isBolded === originalBold))"
            (click)="updateRename()">
            <span class="button-label">Apply</span>
        </button>
    </div>
</div>
